export const p_01 = "/about";
export const p_02 = "/certifications";
export const p_03 = "/contact";
export const p_04 = "/";
export const p_05 = "/portfolio";
export const p_06 = "/resume";
export const p_07 = "/resume-pic";
